import React, { useState, useEffect, useRef } from "react";
import { ColorRing } from "react-loader-spinner";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { GetDailyTanya } from "../../../service/service";
import Header from "../../header/Header";
import Banner from "../../banner/Banner";
import Footer from "../../footer/Footer";
import {
  setCookie,
  getCookie,
} from "../../../ReusableFunctions/cookieHandlers";
import { Link } from "react-router-dom";
import { addAttributes } from "../../../ReusableFunctions/handleHtmlAttributes";
import CustomAudioPlayer from "../../../ReuseableComponents/CustomPlayer";
import CustomVideoPlayer from "../../../ReuseableComponents/CustomVideoPlayer";
import PDFViewer from "../../../ReuseableComponents/PDFViewer";
import { DocumentIcon } from "../../../assets/icon-file";
import {
  LoadingOverlay,
  LoadingDocFallback,
} from "../../../ReuseableComponents/LoadingDocument";
import isValidMediaUrl from "../../../ReusableFunctions/validateMediaUrl";

function DailyTanya() {
  // Feature flags to control rendering modes
  const USE_NORMALIZED_BLOCKS = true; // Toggle for normalized vs legacy block rendering
  const USE_ENHANCED_COMPONENTS = true; // Toggle for enhanced vs basic media components

  const currentPath = window.location.pathname;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [dataArray, setDataArray] = useState([]);

  // Enhanced state management for advanced components
  const [viewDocuments, setViewDocuments] = useState({});
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [iframeStyle, setIframeStyle] = useState({});
  const [widths, setWidths] = useState({
    screenWidth: window.innerWidth,
    fallbackHeight: window.innerWidth > 550 ? "44px" : "72px",
  });
  const [renderIframeFallback, setRenderIframeFallback] = useState({});
  const [urlTimestamp, setUrlTimestamp] = useState({});
  const iframeRefs = useRef({});
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const { screenWidth, fallbackHeight } = widths;

  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);

    // Optionally, you can also add a listener for navigation changes
    const handleScrollToTop = () => {
      window.scrollTo(0, 0);
    };

    // Attach the listener to the "beforeunload" event
    window.addEventListener("beforeunload", handleScrollToTop);

    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleScrollToTop);
    };
  }, []);
  // Enhanced responsive design handling
  useEffect(() => {
    if (USE_ENHANCED_COMPONENTS) {
      const updateWidths = () => {
        setWidths({
          screenWidth: window.innerWidth,
          fallbackHeight: window.innerWidth > 550 ? "44px" : "72px",
        });
      };
      updateWidths();
      window.addEventListener("resize", updateWidths);
      return () => window.removeEventListener("resize", updateWidths);
    }
  }, [USE_ENHANCED_COMPONENTS]);

  // Enhanced document state initialization
  useEffect(() => {
    if (USE_ENHANCED_COMPONENTS && (data || dataArray.length > 0)) {
      const allClassData =
        dataArray.length > 0 ? dataArray : [data].filter(Boolean);

      allClassData.forEach((classItem) => {
        const blocks = classItem?.normalized_block || classItem?.block || [];

        blocks.forEach((blockItem) => {
          let blockId,
            blockType,
            hasDocument = false;
          const { block_type, block } = blockItem;
          // Checking for cookies for video and audio urls and updating url with timestamp if found
          if (block_type === "video" || block_type === "audio") {
            const url = block.video_src || block.audio_src;
            const savedTime = getCookie(url);
            if (savedTime) {
              const timestampedUrl = `${url}#t=${savedTime}`;
              setUrlTimestamp((prev) => ({ ...prev, [url]: timestampedUrl }));
            }
          }

          if (classItem?.normalized_block) {
            // Handle normalized blocks
            blockId = blockItem.id;
            blockType = blockItem.block_type;
            hasDocument =
              blockType === "file" &&
              (blockItem.block?.file_url || blockItem.block?.download_url);
          } else {
            // Handle legacy blocks
            blockId = blockItem.id;
            blockType = blockItem.type;
            hasDocument = blockType === "Documents" && blockItem.url;
          }

          // Initialize document states for enhanced components
          if (hasDocument) {
            setIframeStyle((prev) => ({
              ...prev,
              [blockId]: { height: "500px", classes: "" },
            }));
            setRenderIframeFallback((prev) => ({
              ...prev,
              [blockId]: false,
            }));
            if (screenWidth < 640) {
              setViewDocuments((prev) => ({ ...prev, [blockId]: false }));
            }
          }
        });
      });

      // Handle document rendering check for larger screens
      if (screenWidth > 639) {
        handleRenderingDoc();
      }
    }
  }, [data, dataArray, USE_ENHANCED_COMPONENTS, screenWidth]);

  useEffect(() => {
    setLoading(true);
    if (currentPath === "/daily-tanya") {
      const data = {
        name: "Tanya",
      };
      ShowDailyTanya(data);
    } else if (currentPath === "/daily-hayom-yom") {
      const data = {
        name: "Hayom Yom",
      };
      ShowDailyTanya(data);
    }
  }, []);

  // Enhanced document rendering handler
  const handleRenderingDoc = () => {
    if (!USE_ENHANCED_COMPONENTS) return;

    setLoadingDocument(true);
    const timeout = setTimeout(() => {
      const allClassData =
        dataArray.length > 0 ? dataArray : [data].filter(Boolean);

      allClassData.forEach((classItem) => {
        const blocks = classItem?.normalized_block || classItem?.block || [];

        blocks.forEach((blockItem) => {
          let blockId,
            url,
            isDocument = false;

          if (classItem?.normalized_block) {
            // Handle normalized blocks
            blockId = blockItem.id;
            if (blockItem.block_type === "file") {
              url = blockItem.block?.file_url || blockItem.block?.download_url;
              isDocument = !!url;
            }
          } else {
            // Handle legacy blocks
            blockId = blockItem.id;
            if (blockItem.type === "Documents") {
              url = blockItem.url;
              isDocument = !!url;
            }
          }

          if (isDocument && url) {
            const docType = url.split(".").pop();
            if ((docType === "pdf" && !isSafari) || docType === "docx") {
              handleIsDocRendered({ id: blockId, docType });
            }
          }
        });
      });
      setLoadingDocument(false);
    }, 1000);
    return () => clearTimeout(timeout);
  };
  const ShowDailyTanya = (data) => {
    GetDailyTanya(data).then((result) => {
      if (result.status) {
        const classItem = result?.data[0];
        if (result.data.length > 0) {
          setDataArray(result.data);
        }
        setData(classItem);
        setLoading(false);
      }
    });
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
  };

  const downloadFile = (fileUrl) => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.target = "_blank";
    a.click();
  };

  // Enhanced document handling functions (adapted from SearchClasses)
  const handleViewDocuments = ({ id, docType }) => {
    setViewDocuments((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
    if (docType === "docx" && screenWidth > 639) {
      setLoadingDocument(true);
      setTimeout(() => {
        if (iframeStyle[id]?.classes === "hidden") {
          handleIsDocRendered({ id, docType });
        }
        setLoadingDocument(false);
      }, 1000);
    }
    if (viewDocuments[id]) {
      setRenderIframeFallback((prev) => ({
        ...prev,
        [id]: false,
      }));
      setIframeStyle((prev) => ({
        ...prev,
        [id]: {
          height: prev[id].height,
          classes: docType === "docx" ? "" : iframeStyle[id]?.classes || "",
        },
      }));
    }
  };

  const handleIsDocRendered = ({ id, docType }) => {
    const isDocRendered = !iframeRefs.current[id]?.contentDocument;
    if (
      !isDocRendered ||
      (!isDocRendered &&
        !iframeRefs.current[id]?.contentDocument?.body?.innerHTML)
    ) {
      setIframeStyle((prev) => ({
        ...prev,
        [id]: { height: prev[id]?.height || "500px", classes: "hidden" },
      }));
      setRenderIframeFallback((prev) => ({
        ...prev,
        [id]: true,
      }));
    } else {
      setIframeStyle((prev) => ({
        ...prev,
        [id]: {
          height: prev[id]?.height || "500px",
          classes:
            docType === "pdf"
              ? "border-b-[2px] border-[#333639]"
              : "border-y-[3px] border-[#313131]",
        },
      }));
    }
  };

  // Helper functions for normalized block rendering
  const renderFileBlock = (block, id) => {
    const url = block.file_url || block.download_url;
    if (!url) return null;

    return (
      <>
        {screenWidth < 640 && (
          <div>
            <button
              onClick={() =>
                handleViewDocuments({
                  id: id,
                  docType: url.split(".").pop(),
                })
              }
              type="button"
              className={`mx-auto w-[75%] text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-md px-5 py-1.5 flex gap-2 items-center justify-center ${
                viewDocuments[id] ? "mb-3" : ""
              }`}
            >
              <DocumentIcon classes="w-6 h-6" />
              <span className="w-32">
                {viewDocuments[id] ? "Hide Document" : "View Document"}
              </span>
            </button>
          </div>
        )}
        {url.split(".").pop() === "pdf" &&
          ((screenWidth < 640 && viewDocuments[id] === true) ||
            (isSafari && screenWidth > 639)) && (
            <PDFViewer id={id} pdfUrl={url} downloadFile={downloadFile} />
          )}
        {((isSafari &&
          url.split(".").pop() !== "pdf" &&
          (screenWidth > 639 ||
            (screenWidth < 640 && viewDocuments[id] === true))) ||
          (!isSafari &&
            ((screenWidth < 640 &&
              url.split(".").pop() !== "pdf" &&
              viewDocuments[id] === true) ||
              screenWidth > 639))) && (
          <div id={id} className="relative">
            {loadingDocument && (
              <LoadingOverlay
                height="[500px]"
                text="Loading Document..."
                textSize="text-sm"
                classes="absolute top-0"
                textClasses={`${fallbackHeight === "72px" ? "my-5" : ""}`}
              />
            )}
            {screenWidth > 639 && (
              <iframe
                title="document"
                className={iframeStyle[id]?.classes}
                ref={(el) => (iframeRefs.current[id] = el)}
                src={
                  url.split(".").pop() === "docx"
                    ? `https://docs.google.com/gview?url=${url}&embedded=true`
                    : url
                }
                type={
                  url.split(".").pop() === "pdf"
                    ? "application/pdf"
                    : url.split(".").pop() === "docx"
                      ? "text/html"
                      : ""
                }
                width="100%"
                height={iframeStyle[id]?.height}
              />
            )}
            {(renderIframeFallback[id] || screenWidth < 640) && (
              <LoadingDocFallback
                id={id}
                url={url}
                downloadFile={downloadFile}
              />
            )}
          </div>
        )}
      </>
    );
  };

  const renderParagraphBlock = (block, id) => {
    const content = block.paragraph_text || block.paragraph_html;
    if (!content) return null;

    return (
      <div className="text-primaryDark text-lg font-semibold">
        {block.paragraph_text ? (
          content
        ) : (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    );
  };

  const renderAudioBlock = (block, id) => {
    const audioUrl = block.audio_src;
    if (isValidMediaUrl(audioUrl, "audio") === false) {
      return (
        <div className="text-xl text-red-500">Audio currently unavailable.</div>
      );
    }

    return (
      <div>
        <CustomAudioPlayer
          audioUrl={{ url: audioUrl, urlTimestamp: urlTimestamp[audioUrl] }}
          logRecentlyPlayed={() => {}} // Simplified for DailyTanya context
        />
      </div>
    );
  };

  const renderVideoBlock = (block, id) => {
    const videoUrl = block.video_src;
    if (isValidMediaUrl(videoUrl, "video") === false) {
      return (
        <div className="text-xl text-red-500">Video currently unavailable.</div>
      );
    }

    return (
      <div>
        <CustomVideoPlayer
          videoUrl={{ url: videoUrl, urlTimestamp: urlTimestamp[videoUrl] }}
          logRecentlyPlayed={() => {}} // Simplified for DailyTanya context
        />
      </div>
    );
  };

  const renderImageBlock = (block, id) => {
    const imageUrl = block.image_url || block.url;
    if (!imageUrl) return null;

    return (
      <div className="flex justify-center rounded-lg">
        <img src={imageUrl} alt="class" />
      </div>
    );
  };

  const renderHtmlBlock = (block, id) => {
    const htmlContent = block.html_block;
    if (!htmlContent) return null;

    const processedHtml = addAttributes(htmlContent);

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: processedHtml,
        }}
      />
    );
  };

  // Main normalized block renderer
  const renderNormalizedBlock = (normalized) => {
    const { block_type, block, id } = normalized;

    switch (block_type) {
      case "file":
        return renderFileBlock(block, id);
      case "paragraph":
        return renderParagraphBlock(block, id);
      case "audio":
        return renderAudioBlock(block, id);
      case "video":
        return renderVideoBlock(block, id);
      case "image":
        return renderImageBlock(block, id);
      case "html":
        return renderHtmlBlock(block, id);
      default:
        console.warn(`Unknown normalized block type: ${block_type}`);
        return null;
    }
  };

  // Legacy block renderer with option for enhanced components
  const renderLegacyBlock = (obj, useEnhanced = USE_ENHANCED_COMPONENTS) => {
    if (obj.type === "Audio" && isValidMediaUrl(obj.url, "audio") === false)
      return null;
    if (obj.type === "Video" && isValidMediaUrl(obj.url, "video") === false)
      return null;

    const processedHtml =
      obj.type === "Custom HTML" ? addAttributes(obj.html) : null;
    return (
      <>
        {obj.type === "Paragraph" && (
          <div className="text-primaryDark text-lg font-semibold">
            {obj.description}
          </div>
        )}
        {obj.type === "Video" && (
          <div>
            {useEnhanced ? (
              <CustomVideoPlayer
                videoUrl={{ url: obj.url, urlTimestamp: urlTimestamp[obj.url] }}
                logRecentlyPlayed={() => {}} // Simplified for DailyTanya context
              />
            ) : (
              <video
                playsInline
                className="rounded-lg w-full bg-whiteGrey"
                controls
              >
                <source src={obj.url} type="video/mp4" />
              </video>
            )}
          </div>
        )}
        {obj.type === "Audio" && (
          <div>
            {useEnhanced ? (
              <CustomAudioPlayer
                audioUrl={{ url: obj.url, urlTimestamp: urlTimestamp[obj.url] }}
                logRecentlyPlayed={() => {}} // Simplified for DailyTanya context
              />
            ) : (
              <div className="bg-[#f1f3f4] rounded-lg">
                <audio controls className="w-full">
                  <source src={obj.url} type="audio/ogg" />
                  <source src={obj.url} type="audio/mpeg" />
                  Your browser does not support the audio tag.
                </audio>
              </div>
            )}
          </div>
        )}
        {obj.type === "Documents" && (
          <>
            {useEnhanced ? (
              renderFileBlock({ file_url: obj.url }, obj.id)
            ) : (
              <>
                <object
                  data={obj.url}
                  type="application/pdf"
                  width="100%"
                  height="500px"
                >
                  <p>
                    Unable to display PDF file. <a href={obj.url}>Download</a>{" "}
                    instead.
                  </p>
                </object>
                <div className="flex justify-center py-4">
                  <button
                    className="flex gap-x-2 w-[173px] h-11 items-center justify-center rounded-3xl border-primaryBlue border-[1px] hover:bg-opacity-[0.9] text-sm md:text-base font-semibold leading-7 text-primaryBlue shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    onClick={() => downloadFile(obj.url)}
                  >
                    Download pdf
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12.3798 17.92C12.5026 17.8724 12.6147 17.801 12.7098 17.71L17.7098 12.71C17.8031 12.6168 17.877 12.5061 17.9275 12.3842C17.9779 12.2624 18.0039 12.1319 18.0039 12C18.0039 11.7337 17.8981 11.4783 17.7098 11.29C17.6166 11.1968 17.5059 11.1228 17.3841 11.0723C17.2622 11.0219 17.1317 10.9959 16.9998 10.9959C16.7335 10.9959 16.4781 11.1017 16.2898 11.29L12.9998 14.59L12.9998 7C12.9998 6.73478 12.8945 6.48043 12.7069 6.29289C12.5194 6.10536 12.265 6 11.9998 6C11.7346 6 11.4802 6.10536 11.2927 6.29289C11.1052 6.48043 10.9998 6.73478 10.9998 7L10.9998 14.59L7.70981 11.29C7.61685 11.1963 7.50625 11.1219 7.38439 11.0711C7.26253 11.0203 7.13183 10.9942 6.99981 10.9942C6.8678 10.9942 6.7371 11.0203 6.61524 11.0711C6.49338 11.1219 6.38278 11.1963 6.28982 11.29C6.19609 11.383 6.12169 11.4936 6.07092 11.6154C6.02015 11.7373 5.99402 11.868 5.99402 12C5.99402 12.132 6.02015 12.2627 6.07092 12.3846C6.12169 12.5064 6.19609 12.617 6.28982 12.71L11.2898 17.71C11.3849 17.801 11.4971 17.8724 11.6198 17.92C11.8633 18.02 12.1364 18.02 12.3798 17.92Z"
                          fill="#186CCE"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </>
            )}
          </>
        )}
        {obj.type === "Images" && (
          <div className="flex justify-center rounded-lg">
            <img src={obj.url} alt="class" />
          </div>
        )}
        {obj.type === "Custom HTML" && (
          <div
            dangerouslySetInnerHTML={{
              __html: processedHtml,
            }}
          />
        )}
      </>
    );
  };

  // Shared block rendering function that handles both normalized and legacy blocks
  const renderBlocks = (classData) => {
    // Determine if we should use normalized blocks
    const useNormalized =
      USE_NORMALIZED_BLOCKS &&
      Array.isArray(classData?.normalized_block) &&
      classData.normalized_block.length > 0;

    if (useNormalized) {
      // Use normalized blocks - sort by position and render
      const sortedBlocks = [...classData.normalized_block].sort(
        (a, b) => a.position - b.position,
      );

      return sortedBlocks.map((normalized) => (
        <div
          key={`${normalized.id}-${normalized.block_type}`}
          className="mb-10"
        >
          {renderNormalizedBlock(normalized)}
        </div>
      ));
    } else {
      // Use legacy blocks with enhanced components option
      return classData?.block?.map((obj) => (
        <div key={obj.id} className="mb-10">
          {renderLegacyBlock(obj)}
        </div>
      ));
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/js-cookie@2/src/js.cookie.min.js"></script>
        <script type="text/javascript">{setCookie() + getCookie()}</script>
      </Helmet>
      <div className="flex flex-col min-h-screen">
        <Header />
        <Banner title={dataArray.length > 1 ? "" : data?.title} />
        {loading ? (
          <div className="flex justify-center grow min-h-[200px]">
            <ColorRing
              visible={true}
              height="80"
              width="80"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#D2D6DC", "#D2D6DC", "#D2D6DC", "#D2D6DC", "#D2D6DC"]}
            />
          </div>
        ) : (
          <div className="grow">
            {dataArray.length > 1 ? (
              <>
                {dataArray.length > 0 ? (
                  <section className="px-2 xs:px-5 py-6 md:pt-8 md:pb-[100px] min-h-[40vh]">
                    {dataArray.map((data) => (
                      <div
                        key={data.id}
                        className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto text-primaryDark mb-12"
                      >
                        <h2 className="text-primaryDark leading-[normal] text-[22px] md:text-[40px] font-extrabold">
                          {data?.title}
                        </h2>
                        <div className="text-primaryDark text-sm font-semibold opacity-50 mb-3">
                          {data?.created_at &&
                            `Posted : ${formatDate(
                              data?.is_publish_date ?? data?.created_at,
                            )}`}
                        </div>
                        {renderBlocks(data)}
                        {data?.tags?.length > 0 && (
                          <div className="flex flex-wrap gap-3 mt-6 mb-4">
                            {data?.tags?.map((tag, index) => (
                              <Link
                                key={index + "item"}
                                to={`/tag/${tag?.slug}`}
                                className="py-2 px-6 bg-primaryDark rounded-md text-base text-whiteGrey"
                              >
                                {tag.name}
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </section>
                ) : (
                  <div className="text-primaryDark text-lg font-bold text-center pt-10 h-[50vh]">
                    No Data Found
                  </div>
                )}
              </>
            ) : (
              <>
                {data ? (
                  <section className="px-2 xs:px-5 pt-6 pb-[38px] md:pt-8 md:pb-[100px]">
                    <div className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto text-primaryDark">
                      <div className="text-primaryDark text-sm font-semibold opacity-50 mb-3">
                        {data?.created_at &&
                          `Posted : ${formatDate(
                            data?.is_publish_date ?? data?.created_at,
                          )}`}
                      </div>

                      {renderBlocks(data)}
                      {data?.tags?.length > 0 && (
                        <div className="flex flex-wrap gap-3 mt-6 mb-4">
                          {data?.tags?.map((tag, index) => (
                            <Link
                              key={index + "item"}
                              to={`/tag/${tag?.slug}`}
                              className="py-2 px-6 bg-primaryDark rounded-md text-base text-whiteGrey"
                            >
                              {tag.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  </section>
                ) : (
                  <div className="text-primaryDark text-lg font-bold text-center pt-10 h-[50vh]">
                    No Data Found
                  </div>
                )}
              </>
            )}
          </div>
        )}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default DailyTanya;
